import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InputValueState } from '@components/channel/channel-text-input/channel-text-input.component';
import { ExhaustGasSetting } from 'icreate/common/models/exhaust-gas-setting';
import * as _ from 'lodash';

@Component({
    selector: 'app-edit-exhaust-title-dialog',
    templateUrl: './edit-exhaust-title-dialog.component.html',
    styleUrl: './edit-exhaust-title-dialog.component.css',
    standalone: false,
})
export class EditExhaustTitleDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            currentSetting: ExhaustGasSetting;
            currentSettings: ExhaustGasSetting[];
            isDuplicate: boolean;
        },
        private dialogRef: MatDialogRef<EditExhaustTitleDialogComponent>
    ) {}

    title: string = '';
    hasErrors: boolean = false;
    isDuplicate: boolean = false;

    currentSettings: ExhaustGasSetting[];

    ngOnInit() {
        if (this.data.currentSetting) {
            this.title = this.data.currentSetting.title;
        }
        if (this.data.isDuplicate) {
            this.isDuplicate = this.data.isDuplicate;
        }

        this.currentSettings = _.cloneDeep(this.data.currentSettings);
        this.currentSettings = this.currentSettings.filter(setting => !_.isEqual(this.data.currentSetting, setting));
        this.titleValidation;
    }

    isCreateDisabled() {
        if (this.isDuplicate) return !this.title || this.hasErrors;
        return !this.title || this.title == this.data.currentSetting.title || this.hasErrors;
    }

    updateTitle() {
        if (this.isCreateDisabled()) return;
        this.dialogRef.close(this.title);
    }

    get titleValidation(): {
        state: InputValueState;
        message?: string;
        errorExtraInfo?: any;
    } {
        const isInvalid = !this.title || this.title.length === 0;
        this.hasErrors = false;

        if (isInvalid) {
            this.hasErrors = true;
            return {
                state: InputValueState.error,
                message: 'exhaust-setting.edit-title.required',
                errorExtraInfo: null,
            };
        }

        const isRepeated = this.currentSettings?.find(setting => setting.title == this.title);

        if (isRepeated) {
            this.hasErrors = true;
            return {
                state: InputValueState.error,
                message: 'exhaust-setting.edit-title.repeated',
                errorExtraInfo: null,
            };
        }

        return {
            state: InputValueState.normal,
            message: undefined,
            errorExtraInfo: null,
        };
    }

    closeDialog() {
        this.dialogRef.close();
    }
}
